// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"badge_wrapper__3pJpU","hasText":"badge_hasText__p_MBe","text":"badge_text__fNQpw","imageSmall":"badge_imageSmall__baaq2","imageBig":"badge_imageBig__ED3Q_"};